import { CustomRouteConfig } from "@/models/plugins/CustomRouterTypes";
import PERMISSIONS from "@/static/permissions";

export const COST_DOCUMENT_ROUTE_NAMES = {
  NEW_COST_DOCUMENT: "New cost document",
  EDIT_COST_DOCUMENT: "Edit cost document",
  CREATE_CORRECTION_COST_DOCUMENT: "Create correction cost document",
  PAIR_COST_DOCUMENT: "Pair cost documents",
  COST_DOCUMENTS_VM: "Cost documents VM",
};

const CostDocumentsRoutes: Array<CustomRouteConfig> = [
  {
    name: COST_DOCUMENT_ROUTE_NAMES.NEW_COST_DOCUMENT,
    path: "cost-documents/new",
    component: () => import(/* webpackChunkName: "costDocuments" */ "@/views/costDocuments/CostDocumentNewView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CostDocumentsCreate] },
  },
  {
    name: COST_DOCUMENT_ROUTE_NAMES.EDIT_COST_DOCUMENT,
    path: "cost-documents/edit/:id",
    component: () => import(/* webpackChunkName: "costDocuments" */ "@/views/costDocuments/CostDocumentEditView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CostDocumentsUpdate] },
  },
  {
    name: COST_DOCUMENT_ROUTE_NAMES.CREATE_CORRECTION_COST_DOCUMENT,
    path: "cost-documents/correction/:id",
    component: () =>
      import(/* webpackChunkName: "costDocuments" */ "@/views/costDocuments/CostDocumentCreateCorrectionView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CostDocumentsCreate] },
  },
  {
    name: COST_DOCUMENT_ROUTE_NAMES.PAIR_COST_DOCUMENT,
    path: "cost-documents/pair/:id",
    component: () => import(/* webpackChunkName: "costDocuments" */ "@/views/costDocuments/CostDocumentsPairView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CostDocumentsUpdate] },
  },
  {
    name: COST_DOCUMENT_ROUTE_NAMES.COST_DOCUMENTS_VM,
    path: "cost-documents",
    component: () => import(/* webpackChunkName: "costDocuments" */ "@/views/costDocuments/CostDocumentsVMView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.CostDocumentsRead] },
  },
];

export { CostDocumentsRoutes };
export default CostDocumentsRoutes;
